import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "娱乐新闻", to: "/category/entertainment" },
  { label: "明星绯闻", to: "/category/gossip" },
  { label: "社会热点", to: "/category/society" },
  { label: "专题", to: "/topic/topic-drama-2026" },
  { label: "关于", to: "/about" },
];

const todayLabel = "2026 年 10 月 17 日 · 星期六";

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-40 w-full">
      <div className="hidden md:block bg-primary-950 text-background-200">
        <div className="w-full px-6 h-9 flex items-center justify-between text-xs tracking-wide">
          <span className="text-background-300">{todayLabel} · 吃瓜要理性，信息看来源</span>
          <div className="flex items-center gap-5">
            <span className="text-accent-300">今日新增 18 条资讯</span>
            <Link to="/about" className="hover:text-background-50 transition-colors">
              投稿与合作
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full bg-background-50/95 backdrop-blur border-b border-background-200">
        <div className="w-full px-4 md:px-6 h-16 md:h-[76px] flex items-center gap-4 md:gap-8">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="黑料吃瓜网首页">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg md:text-xl font-bold">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-[22px] font-bold text-foreground-950 tracking-tight">
                黑料吃瓜网
              </span>
              <span className="hidden sm:block text-[10px] tracking-[0.22em] text-foreground-500 mt-1 uppercase">
                Hei Liao News
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1 flex-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  [
                    "px-3.5 py-2 text-[15px] rounded-md whitespace-nowrap transition-colors cursor-pointer",
                    isActive
                      ? "text-primary-600 font-medium bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100",
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex items-center ml-auto">
            <div className="flex items-center gap-2 bg-background-100 border border-background-300/70 rounded-full pl-4 pr-1 py-1 focus-within:border-primary-400 transition-colors">
              <i className="ri-search-line text-foreground-500 text-sm" />
              <input
                ref={inputRef}
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索明星、剧集或热点"
                className="bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none w-40 xl:w-56"
                aria-label="站内搜索"
              />
              <button
                type="submit"
                className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                搜索
              </button>
            </div>
          </form>

          <div className="flex items-center gap-2 ml-auto md:ml-0">
            <Link
              to="/search"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fadeIn">
            <div className="px-4 py-4 space-y-3">
              <form onSubmit={submitSearch} className="flex items-center gap-2">
                <div className="flex items-center gap-2 flex-1 bg-background-100 border border-background-300/70 rounded-full pl-4 pr-1 py-1">
                  <i className="ri-search-line text-foreground-500 text-sm" />
                  <input
                    value={keyword}
                    onChange={(event) => setKeyword(event.target.value)}
                    placeholder="搜索明星、剧集或热点"
                    className="bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none flex-1 min-w-0"
                    aria-label="站内搜索"
                  />
                </div>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer"
                >
                  搜索
                </button>
              </form>
              <div className="grid grid-cols-2 gap-2">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/"}
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      [
                        "px-4 py-2.5 rounded-md text-sm flex items-center justify-between cursor-pointer",
                        isActive
                          ? "bg-primary-50 text-primary-600 font-medium"
                          : "bg-background-100 text-foreground-700",
                      ].join(" ")
                    }
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-foreground-400" />
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}